import { render, staticRenderFns } from "./CoursesFactTransition.vue?vue&type=template&id=4b6fd4c0&scoped=true&"
import script from "./CoursesFactTransition.vue?vue&type=script&lang=js&"
export * from "./CoursesFactTransition.vue?vue&type=script&lang=js&"
import style0 from "./CoursesFactTransition.vue?vue&type=style&index=0&id=4b6fd4c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6fd4c0",
  null
  
)

export default component.exports